import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "letting-engine:recently-viewed";
const MAX_ITEMS = 6;

function readRecentIds(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is number => typeof id === "number");
  } catch {
    return [];
  }
}

function writeRecentIds(ids: number[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

export function useRecentlyViewed() {
  const [recentIds, setRecentIds] = useState<number[]>(readRecentIds);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) {
        setRecentIds(readRecentIds());
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const addViewed = useCallback((id: number) => {
    setRecentIds((prev) => {
      const without = prev.filter((recentId) => recentId !== id);
      const next = [id, ...without].slice(0, MAX_ITEMS);
      writeRecentIds(next);
      return next;
    });
  }, []);

  return { recentIds, addViewed };
}
